export const movements = [
    { id: 1, materialId: 1, date: "2024-11-20", type: "Entrée", quantity: 100, description: "Livraison du fournisseur A" },
    { id: 2, materialId: 1, date: "2024-11-22", type: "Sortie", quantity: 50, description: "Utilisé pour la production" },
    { id: 3, materialId: 2, date: "2024-11-19", type: "Entrée", quantity: 200, description: "Livraison du fournisseur B" },
    { id: 4, materialId: 3, date: "2024-11-18", type: "Sortie", quantity: 30, description: "Test qualité" },
    { id: 5, materialId: 2, date: "2024-11-25", type: "Sortie", quantity: 100, description: "Production spéciale" },
];
